import { Country } from '@resurs-internal/mui/assets/countries';

import { type AvailableCountry } from '@/models';
import { InterestRateType } from '@/types/consumer-deposit-application-service';

export enum SectionType {
  ContactInfo = 'contactInfo',
  DisbursementAccount = 'disbursementAccount',
  Autogiro = 'autogiro',
  Bankruptcy = 'bankruptcy',
  Kyc = 'kyc',
}

export const getSectionMap = (
  country: AvailableCountry,
  productType: InterestRateType | undefined,
): SectionType[] => {
  const isVariableProduct =
    country === Country.SE && productType === InterestRateType.VARIABLE;

  const sectionMaps: Record<AvailableCountry, SectionType[]> = {
    [Country.DK]: [SectionType.ContactInfo, SectionType.Kyc],
    [Country.NO]: [
      SectionType.ContactInfo,
      SectionType.DisbursementAccount,
      SectionType.Bankruptcy,
      SectionType.Kyc,
    ],
    [Country.SE]: isVariableProduct
      ? [SectionType.ContactInfo, SectionType.Autogiro, SectionType.Kyc]
      : [SectionType.ContactInfo, SectionType.Kyc],
  };

  return sectionMaps[country] || [];
};

export const getSectionCount = (
  country: AvailableCountry,
  productType?: InterestRateType | undefined,
) => {
  const sections = getSectionMap(country, productType);

  return sections.length + (sections.includes(SectionType.Bankruptcy) ? 1 : 2);
};

export const hasSectionType = (
  country: AvailableCountry,
  productType: InterestRateType | undefined,
  sectionType: SectionType,
): boolean => {
  return getSectionMap(country, productType).includes(sectionType);
};

export const getSectionType = (
  section: number,
  country: AvailableCountry,
  productType: InterestRateType | undefined,
): SectionType | null => {
  const sections = getSectionMap(country, productType);

  return sections[section] || null;
};
